(() => {
  const COOKIE_PREFERENCES_SELECTOR = '[data-sop-cookie-preferences]';

  function setupCookiePreferencesButtons() {
    const buttons = document.querySelectorAll(COOKIE_PREFERENCES_SELECTOR);
    if (!buttons.length) return true;

    const privacyBanner = window.privacyBanner;
    if (!privacyBanner || typeof privacyBanner.showPreferences !== 'function') return false;

    for (const button of buttons) {
      const hasNativeControl = [...document.querySelectorAll('a, button')].some((element) => {
        if (element === button || element.matches(COOKIE_PREFERENCES_SELECTOR)) return false;
        return element.textContent?.trim().toLowerCase() === 'cookie preferences';
      });

      if (hasNativeControl) continue;

      button.hidden = false;
      if (button.dataset.sopCookiePreferencesReady === 'true') continue;

      button.dataset.sopCookiePreferencesReady = 'true';
      button.addEventListener('click', () => {
        try {
          const result = privacyBanner.showPreferences();
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch {
          // Shopify owns the preference modal. Leave the page usable if it is temporarily unavailable.
        }
      });
    }

    return true;
  }

  function initializeCookiePreferences() {
    if (setupCookiePreferencesButtons()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (setupCookiePreferencesButtons() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCookiePreferences, { once: true });
  } else {
    initializeCookiePreferences();
  }
})();

